import React, { useContext } from "react";
import "./operationsScreen.css";
import { DataLayerContext } from "../dataLayer/DataLayer";
import { useObservableProperty } from "../observable/useObservableProperty";
import { AppBar } from "./components/appBar";
import {
  Dashboard,
  nearestChartIndex,
} from "./components/operationsDashboard";
import { PageHeading } from "./components/pageHeading";

export { nearestChartIndex };

export function OperationsScreen() {
  const dataLayer = useContext(DataLayerContext);
  const dashboard = useObservableProperty(dataLayer.operationsDashboard);

  return (
    <div className="screen operations">
      <AppBar title="Operations" onBack={() => dataLayer.navigateBack()} />
      <div className="operations__body">
        <PageHeading
          eyebrow="Private"
          title="Wirder dashboard"
          sub="Operational activity and puzzle coverage."
        />
        {dashboard.status === "loaded" ? (
          <Dashboard data={dashboard.data} />
        ) : dashboard.status === "unauthorized" ? (
          <div className="ops__state">
            <h2>Page not available</h2>
            <p>This account does not have access to operational data.</p>
          </div>
        ) : dashboard.status === "error" ? (
          <div className="ops__state">
            <h2>Couldn&rsquo;t load operations</h2>
            <p>The dashboard data could not be retrieved.</p>
            <button
              className="btn btn--secondary"
              onClick={() => dataLayer.loadOperationsDashboard()}
            >
              Try again
            </button>
          </div>
        ) : (
          <div className="ops__state" aria-busy="true">
            <p>Loading operational data&hellip;</p>
          </div>
        )}
      </div>
    </div>
  );
}
